import type { ReactNode } from "react";

interface ProgressBarProps {
  done: number;
  total: number;
  /** Spoken value, e.g. "2 van 5 lessen afgerond". */
  valueText: string;
  labelledBy: string;
}

export const ProgressBar = ({
  done,
  total,
  valueText,
  labelledBy,
}: ProgressBarProps): ReactNode => (
  <div
    role="progressbar"
    aria-labelledby={labelledBy}
    aria-valuemin={0}
    aria-valuemax={total}
    aria-valuenow={done}
    aria-valuetext={valueText}
    className="h-3 overflow-hidden rounded-full border border-border bg-muted">
    <div
      className="h-full rounded-full bg-primary transition-[width] duration-500"
      style={{ width: `${total === 0 ? 0 : Math.round((done / total) * 100)}%` }}
    />
  </div>
);
